import moment from 'moment';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React from 'react';
import { withTranslation } from 'react-i18next';
import publicIp from 'react-public-ip';
import { v4 as uuidv4 } from 'uuid';
import BaseContainer from '../baseContainers/BaseContainer';
import { ActionButton } from '../components/ActionButton';
import { ActionLink } from '../components/ActionLink';
import { CustomMessages } from '../components/CustomMessages';
import DivContainer from '../components/DivContainer';
import FuelCardComponent from '../components/FuelCardComponent';
import InputCalendarComponent from '../components/inputs/InputCalendarComponent';
import InputCheckboxComponent from '../components/inputs/InputCheckboxComponent';
import InputDropdownComponent from '../components/inputs/InputDropdownComponent';
import InputFileChooseComponent from '../components/inputs/InputFileChooseComponent';
import InputRadioButtonComponent from '../components/inputs/InputRadioButtonComponent';
import InputTextComponent from '../components/inputs/InputTextComponent';
import MenuItemIcon from '../components/MenuItemIcon';
import PhoneNumberComponent from '../components/PhoneNumberComponent';
import { Steps } from '../components/StepsComponent';
import BlockUi from '../components/waitPanel/BlockUi';
import AutoRegistrationService from '../services/AutoRegistrationService';
import SettingService from '../services/SettingService';
import SelectCustomerDialog from './SelectCustomerDialog';

class AutoRegistrationByBankContainer extends BaseContainer {
    constructor(props) {
        super(props);
        const { t } = this.props;
        this.autoRegistrationService = new AutoRegistrationService();
        this.settingService = new SettingService();
        this.renderFirstPage = this.renderFirstPage.bind(this);
        this.renderFirstFormPage = this.renderFirstFormPage.bind(this);
        this.renderSecondPage = this.renderSecondPage.bind(this);
        this.renderThirdPage = this.renderThirdPage.bind(this);
        this.renderFourthPage = this.renderFourthPage.bind(this);
        this.renderFinalPage = this.renderFinalPage.bind(this);
        this.renderBackButton = this.renderBackButton.bind(this);
        this.renderNextButton = this.renderNextButton.bind(this);
        this.renderAddCardButton = this.renderAddCardButton.bind(this);
        this.renderDeleteCardButton = this.renderDeleteCardButton.bind(this);
        this.addFuelCard = this.addFuelCard.bind(this);
        this.renderStepsNav = this.renderStepsNav.bind(this);
        this.renderToLoginButton = this.renderToLoginButton.bind(this);
        this.renderToFormChooseButton = this.renderToFormChooseButton.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.setCheckAll = this.setCheckAll.bind(this);
        this.uncheckAll = this.uncheckAll.bind(this);
        this.checkCheckAll = this.checkCheckAll.bind(this);
        this.checkPromoCode = this.checkPromoCode.bind(this);
        this.completeRegistration = this.completeRegistration.bind(this);
        this.state = {
            pageIndex: 0,
            errorCode: undefined,
            maxFuelCards: 5,
            checkAll: undefined,
            invoiceTypeDescriptions: [t('autoRegistration.invoiceDescription1'), t('autoRegistration.invoiceDescription2')],
            invoiceTypeOptions: [],
            companyStatusOptions: [],
            fuelCardTypeOptions: [],
            companyBusinessOptions: [],
            customerOptions: [],
            registrationStart: undefined,
            selectedCustomer: undefined,
            selectCustomerDialogVisible: false,
            flatRateFarmerDialogVisible: false,
            agreementTypeOptions: [],
            telephoneCodeOptions: [],
            provinceOptions: [],
            formChoosen: undefined,
            nipVerified: false,
            nipSentVerified: false,
            nipVerificationLoading: false,
            agreementVerificationLoading: false,
            agreementSentDate: undefined,
            isAgreementChecked: false,
            fuelCardAppRoleOptions: [
                //placeholder
                { enumValue: 'DRIVER', label: t('AccountRole.DRIVER') },
                { enumValue: 'ADMIN', label: t('AccountRole.ADMIN') },
            ],
            cardOptions: [
                { enumValue: 'PLASTIC', label: t('autoRegistration.cardPlasticBasic'), description: t('autoRegistration.plasticCardDescription') },
                { enumValue: 'PLASTIC_MULTIENERGETIC', label: t('autoRegistration.cardPlasticMultienergetic'), description: t('autoRegistration.electromobilityCardDescription') },
            ],
            flatRateFarmerOptions: [
                { enumValue: 'SELF_EMPLOYED', label: t('autoRegistration.nonFlatRateFarmerMessage') },
                { enumValue: 'FLAT_RATE_FARMER', label: t('autoRegistration.flatRateFarmerMessage') },
            ],
            formsOptions: [
                { enumValue: 'FIRST', label: t('autoRegistration.sendBankClientAgreementForm'), description: t('autoRegistration.sendBankClientAgreementFormDescription') },
                { enumValue: 'SECOND', label: t('autoRegistration.sendBankClientRegistrationForm'), description: t('autoRegistration.sendBankClientRegistrationFormDescription') }
            ],
            bankOptions: [
                { enumValue: 'BPS', label: t(`autoRegistration.bankOptions.BPS`) },
                { enumValue: 'SGB', label: t(`autoRegistration.bankOptions.SGB`) }
            ],
            flatRateFarmer: false,
            approvals: [],
            element: {
                bankName: undefined,
                ownerPhoneCode: undefined,
                ownerPhoneValue: '',
                userIp: '',
                promoCodeId: '',
                promoCodeDateFrom: '',
                promoCodeDateTo: '',
                promoCode: '',
                offerType: 'CASH',
                tin: '',
                regon: '',
                ownerEmail: '',
                companyName: '',
                email: '',
                ownerPhone: '',
                companyBusiness: undefined,
                companyStatus: undefined,
                companyContactAddress: '',
                contactStreet: '',
                contactNumber: '',
                contactPostCode: '',
                contactPostOffice: '',
                invoiceType: 'ELECTRONIC',
                invoiceFrequency: undefined,
                cards: [],
                cardCompanyName: '',
                marketingConsent: false,
                phoneMarketing: false,
                emailMarketing: false,
                //newsletterMarketingConsent: false,
                approvalContent3: false,
                petraAgreements: [],
                existsInOtherRole: undefined,
                cbkId: undefined,
                customerDataChange: false,
                fullAddress: {
                    city: '',
                    street: '',
                    streetNumber: '',
                    flatNumber: '',
                    postCode: '',
                    postOffice: '',
                    provinceId: '',
                },
                companyAuthorized: false,
                flatRateFarmer: undefined,
                vehicleType: undefined,
                emailStatementFile: undefined,
                registrationStatementFile: undefined,
                krsFile: undefined,
                bankEmployeeFirstame:undefined,
                bankEmployeeLastname: undefined,
                bankEmployeeEmail: undefined,
                bankEmployeePosition: undefined,
                bankEmployeePhone: undefined
            },
        };
    }

    componentDidMount() {
        super.componentDidMount();
        this.readMessage();
        this.blockUi();
        const { t } = this.props;

        const userRole = this.authService.getProfile().helpdeskUserRole;
        const bankName = this.state.bankOptions.find(option => option.enumValue === (userRole === 'BANK_SGB' ? 'SGB' : 'BPS'));        
        this.setState(prevState => ({
            element: {
                ...prevState.element,
                bankName
            }
        }));
        this.enumService
            .getEnumListWithDescription('EcInvoiceType', t)
            .then((invoiceTypeOptions) => {
                if (this._isMounted) {
                    let noPaperOptions = invoiceTypeOptions?.filter(o => o.enumValue !== "PAPER");
                    this.setState(
                        {
                            invoiceTypeOptions : noPaperOptions,
                        },
                        () => {
                            this.unblockUi();
                        }
                    );
                }

            })
            .catch(() => {
                this.showErrorMessage(t('error.typeInvoiceListError'));
                this.unblockUi();
            });
        this.enumService
            .getEnumListWithDescription('EcInvoiceFrequency', t)
            .then((invoiceFrequencyOptions) => {
                if (this._isMounted) {
                    this.setState(
                        {
                            invoiceFrequencyOptions,
                        },
                        () => {
                            this.unblockUi();
                        }
                    );
                }
              
            })
            .catch(() => {
                this.showErrorMessage(t('error.typeInvoiceFrequencyListError'));
                this.unblockUi();
            });
        this.enumService
            .getEnumListWithDescription('EcCardKind', t)
            .then((fuelCardTypeOptions) => {
                const filteredFuelCardTypeOptions = fuelCardTypeOptions.filter(option => option.enumValue === 'FIRM');
                if (this._isMounted) {
                    this.setState(
                        {
                            fuelCardTypeOptions: filteredFuelCardTypeOptions
                        },
                        () => {
                            this.unblockUi();
                        }
                    );
                }

            })
            .catch(() => {
                this.showErrorMessage(t('error.typeInvoiceFrequencyListError'));
                this.unblockUi();
            });
        this.settingService
            .getTelephoneCodeList()
            .then((telephoneCodeOptions) => {
                if (this._isMounted) {
                    this.setState({
                        telephoneCodeOptions: telephoneCodeOptions,
                    });
                }
            })
            .catch(() => { });
        this.settingService
            .getProvinceList()
            .then((provinceOptions) => {
                if (this._isMounted) {
                    this.setState({
                        provinceOptions: provinceOptions,
                    });
                }
            })
            .catch(() => { });
        publicIp.v4().then((response) => {
            this.setState((prevState) => ({
                ...prevState,
                element: {
                    ...prevState.element,
                    userIp: response,
                },
            }));
        });
        // this.autoRegistrationService
        //     .getApprovals(this.state.element.offerType)
        //     .then((approvals) => {
        //         this.setState({ approvals });
        //     })
        //     .catch((err) => {
        //         console.log(err);
        //     });

            this.autoRegistrationService
            .getHybridApprovals()
            .then((approvals) => {
                if (this._isMounted) {
                this.setState({ approvals });}
            })
            .catch((err) => {
                console.log(err);
            });
        this.autoRegistrationService
            .registrationAgreementTypes()
            .then((registrationAgreementTypes) => {
                let agreementTypeOptions = [];
                if (registrationAgreementTypes !== undefined && registrationAgreementTypes !== null) {
                    registrationAgreementTypes.forEach((type) => {
                        agreementTypeOptions.push({
                            enumValue: type,
                            label: `${t(`autoRegistration.registrationAgreementTypes.${type}.label`)}`,
                            description: `${t(`autoRegistration.registrationAgreementTypes.${type}.[html]description`)}`,
                        });
                    });
                }
                if (this._isMounted) {
                this.setState({ agreementTypeOptions });}
            })
            .catch((err) => {
                this.showErrorMessage(t('autoRegistration.registrationAgreementTypes.error'));
            });
        this.settingService
            .getVehicleTypes()
            .then((vehicleTypeOpt) => {
                if (this._isMounted) {
                    this.setState({
                        vehicleTypeOpt,
                    });
                }
            })
            .catch(() => { });
    }

    componentDidUpdate() {
        this.checkCheckAll();
    }

    translate(key) {
        const { t } = this.props;
        return t(key);
    }


    readMessage() {
        const messageFromStorage = this.readCookie(this.getContainerListName());
        if (messageFromStorage !== undefined && messageFromStorage != null) {
            const message = JSON.parse(messageFromStorage);
            this.removeCookie(this.getContainerListName());
            if (
                message.severity !== undefined &&
                message.severity != null &&
                message.summary !== undefined &&
                message.summary != null &&
                message.detail !== undefined &&
                message.detail != null
            ) {
                this.showMessage(message.severity, message.summary, message.detail);
            }
        }
    }

    getContainerListName() {
        return 'bank-start-page'
    }

    checkPromoCode(code) {
        this.blockUi();
        const { t } = this.props;
        this.autoRegistrationService
            .checkPromoCode(code)
            .then((response) => {
                this.setState((prevState) => ({
                    ...prevState,
                    element: {
                        ...prevState.element,
                        promoCodeId: response.id,
                        promoCodeDateFrom: moment(response.dateFrom),
                        promoCodeDateTo: moment(response.dateTo),
                        promoCode: response.code,
                    },
                }));
                this.unblockUi();
            })
            .then(() => {
                const date = new Date();
                if (this.state.element.promoCodeDateFrom < date && this.state.element.promoCodeDateTo > date) {
                    this.setState({ promoCodeValid: true });
                } else {
                    throw new Error();
                }
            })
            .catch(() => {
                this.setState({
                    promoCodeValid: false,
                });
                this.showErrorMessage(t('autoRegistration.invalidRegisterCode'));
                this.unblockUi();
            });
    }

    registrationStart() {
        this.blockUi();
        const { t } = this.props;
        this.autoRegistrationService
            .registrationStart(t)
            .then((response) => {
                this.setState(
                    {
                        registrationStart: response,
                        companyStatusOptions: response.companyStatus,
                        companyBusinessOptions: response.tradeList,
                    },
                    () => this.unblockUi()
                );
            })
            .catch(() => {
                this.showErrorMessage(t('error.registrationStartError'));
                this.unblockUi();
            });
    }

    normalizeNip() {
        return this.state.element?.tin.split('-').join('');
    };

    completeRegistration(file1, file2, file3) {
        this.blockUi();
        const { t } = this.props;
        const { element } = this.state;
        element.tin = this.normalizeNip();
        if (
            element.ownerPhoneCode !== undefined &&
            element.ownerPhoneCode !== null &&
            element.ownerPhoneValue !== undefined &&
            element.ownerPhoneValue !== null &&
            element.ownerPhoneValue !== ''
        ) {
            element.ownerPhone = element.ownerPhoneCode.code + element.ownerPhoneValue;
        }
        this.autoRegistrationService
            .completeRegistration(element, file1, file2, file3)
            .then(() => {
                this.unblockUi(this.setState({ pageIndex: 4, errorCode: undefined }));
            })
            .catch((err) => {
                if (err.integrationErrorCode === 10) {
                    this.unblockUi(this.setState({ pageIndex: 4, errorCode: err.integrationErrorCode }));
                } else {
                    this.showErrorMessage(t('error.autoRegistrationError'));
                    this.unblockUi();
                }
            });
    }

    renderFormChoosePage() {
        const { t } = this.props;
        return (
            <DivContainer >

                <div className='row bank-form-option-button'>

                    <div className='register-header'>
                        {t('autoRegistration.bankClientChooseFormHeader')}

                    </div>
                    <div className='row register-form-choose-btns'>
                    {this.state.formsOptions.map((form, index) => {
                        return (
                            <ActionButton
                                key={`form-choosen-${index}`}
                                label={form.label}
                                id={`form-choosen-${index}`}
                                variant={'button white-black bank-form-type'}
                                colClass='col-6'
                                inputLikeStyle={true}
                                description={<div dangerouslySetInnerHTML={{ __html: form.description }} />}
                                showDescription={true}
                                descriptionClassName='bank-form-type-description'
                                handleClick={() => {
                                    if (form.enumValue === 'FIRST') {
                                        window.location.href = '/#/bank-pre-autoregistration';

                                    }
                                    if (form.enumValue === 'SECOND') {
                                        window.location.href = '/#/bank-autoregistration'

                                    }
                                }


                                    // form.enumValue !== this.state.formChoosen
                                    //     ? () =>
                                    //           this.setState(
                                    //             {formChoosen :  form.enumValue}

                                    //           )
                                    //     : null
                                }
                            />
                        );
                    })}
                    </div>
             
                </div>


                <div className='row footer-buttons'>

                </div>
            </DivContainer>
        );
    }

    afterAddSuccess(response, backUrl,) {
        this.blockUi();
        this.persistMessage('success', '', response);
        window.location.href = backUrl;
    }



    renderFirstFormPage() {
        const { t } = this.props;
        return (
            <DivContainer colClass='row gutter-x-24'>
                <div className='header' >{`1. ${t('autoRegistration.bankDataHeader')}`}</div>
                <InputDropdownComponent
                    id='bankName'
                    name='bankName'
                    label={t('autoRegistration.bankName')}
                    colClass='col-md-4 col-sm-12'
                    value={this.state.element.bankName}
                    viewMode='VIEW'
                    validator={this.validator}
                    validators='required'
                    options={this.state.bankOptions}
                    onChange={this.handleChange}
                    dataKey='enumValue'
                    optionLabel='label'
                    required
                    renderRequired
                />
                <div className='col-12'></div>
                <div className='header'>{`2.  ${t('autoRegistration.bankClientDataHeader')}`}</div>
                <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 nip-with-icon'>
                    <InputTextComponent
                        id='tin'
                        name='tin'
                        label={'NIP klienta'}
                        colClass='col-xl-10 col-lg-10 col-md-10 col-sm-12'
                        value={this.state.element.tin}
                        viewMode='NEW'
                       // onAfterStateChange={() => this.checkCeidgExists()}
                        validator={this.validator}
                        validators='required|nip'
                        onChange={this.handleChange}
                        required
                        renderRequired
                    />

                    {/* {this.state.nipVerificationLoading === true ? null : <MenuItemIcon
                        alt={"Weryfikacja numeru NIP"}
                        className={`nip-verify-icon`}
                        iconSvg={this.state.nipVerified === true ? 'ico_verify_success' : 'ico_verify_error'}
                    />
                    } */}


                    {/* {this.state.nipVerificationLoading === true ? <span className='grey-verified-label'>{t('autoRegistration.tinVerificationLoading')}</span> : this.state.element.tin === '' ? <span className='red-verified-label'>{t('autoRegistration.tinVerifiedInfo')}</span> :
                        this.state.nipVerified === true ? <span className='green-verified-label'>{t('autoRegistration.tinVerifiedSuccess')}</span> :
                            <span className='red-verified-label'>{t('autoRegistration.tinVerifiedError')}</span>} */}


                </div>
                <InputTextComponent
                    id='ownerEmail'
                    name='ownerEmail'
                    label={'Adres e-mail do wysyłki regulaminu '}
                    colClass='col-xl-5 col-lg-5 col-md-5 col-sm-12'
                    value={this.state.element.ownerEmail}
                    viewMode='NEW'
                    validator={this.validator}
                    validators='required|email'
                    onChange={this.handleChange}
                    required
                    renderRequired
                />
                <div className='row footer-buttons'>
                    {this.renderBackButton(0)}
                    {this.renderSaveButton()}
                </div>
            </DivContainer>
        );
    }

    renderFirstPage() {
        const { t } = this.props;
        return (
            <DivContainer colClass='row gutter-x-24'>
                  {this.state.selectCustomerDialogVisible === true ? (
                                    <SelectCustomerDialog
                                        visible={true}
                                        onHide={() => {
                                            this.setState({selectCustomerDialogVisible: false});
                                        }}
                                        closeable
                                        className=''
                                        renderHeader={() => (
                                            <React.Fragment>
                                                <DivContainer colClass='col-12 back-off-auth-dialog-header'>
                                                    <DivContainer colClass='col-12'>
                                                        <label id={`auth-dialog-header-label-id`}>{`${t('autoRegistration.selectCustomerHeader')}`}</label>
                                                    </DivContainer>
                                                </DivContainer>
                                            </React.Fragment>
                                        )}
                                        handleSuccess={(customer) =>
                                            this.setState(
                                                (prevState) => ({
                                                    prevState,
                                                    pageIndex: 1,
                                                    selectCustomerDialogVisible: false,
                                                    element: {
                                                        ...prevState.element,
                                                        fullAddress: {
                                                            city: customer.fullAddress.city,
                                                            street: customer.fullAddress.street,
                                                            streetNumber: customer.fullAddress.streetNumber,
                                                            flatNumber: customer.fullAddress.flatNumber,
                                                            postCode: customer.fullAddress.postCode,
                                                            postOffice: customer.fullAddress.postOffice,
                                                            provinceId: customer.fullAddress.provinceId,
                                                        },
                                                        companyName: customer.fullName,
                                                        email: customer.email,
                                                        existsInOtherRole: customer.existsInOtherRole,
                                                        regon: customer.regon,
                                                        cbkId: customer.cbkId,
                                                        customerDataChange: customer.customerDataChange,
                                                    },
                                                }),
                                                this.registrationStart()
                                            )
                                        }
                                        blockUi={this.blockUi}
                                        unblockUi={this.unblockUi}
                                        showMessage={this.showMessage}
                                        embedded
                                        _isMounted={this._isMounted}
                                        mainRef={this.props.mainRef}
                                        customerOptions={this.state.customerOptions}
                                        provinceOptions={this.state.provinceOptions}
                                    />
                                ) : null}
                <div className='header' dangerouslySetInnerHTML={{ __html: "1. Dane banku" }} />
                <InputDropdownComponent
                    id='bankName'
                    name='bankName'
                    label={t('autoRegistration.bankName')}
                    colClass='col-md-4 col-sm-12'
                    value={this.state.element.bankName}
                    viewMode='VIEW'
                    validator={this.validator}
                    validators='required'
                    options={this.state.bankOptions}
                    onChange={this.handleChange}
                    dataKey='enumValue'
                    optionLabel='label'
                    required
                    renderRequired
                />

                <InputCalendarComponent
                    id='registerDate'
                    name='registerDate'
                    label={"Data rejestracji"}
                    colClass='col-md-4 col-sm-12'
                    value={new Date()}
                    viewMode='VIEW'
                    validator={this.validator}
                    validators='not_required'
                    onChange={this.handleChange}
                    iconSide='right'
                    iconSize='m'
                />
                 {/* <InputCalendarComponent
                        id='agreementSentDate'
                        name='agreementSentDate'
                        label={"Data wysyłki regulaminów"}
                        colClass='col-xl-4 col-lg-4 col-md-4 col-sm-12'
                        value={this.state.agreementSentDate}
                        viewMode='VIEW'
                        validator={this.validator}
                        validators='not_required'
                        onChange={this.handleChange}
                        iconSide='right'
                        iconSize='m'
                        rendered={this.state.agreementSentDate !== undefined && this.state.nipSentVerified === true}
                        disabled={true}
                    /> */}

                <div className='col-12'></div>
                <div className='header'>{"2. Dane klienta"}</div>
                {/* <div className='col-xl-6 col-lg-6 col-md-6 col-sm-12 nip-with-icon'> */}
                    <InputTextComponent
                        id='tin'
                        name='tin'
                        label={'NIP klienta'}
                        colClass='col-xl-4 col-lg-4 col-md-6 col-sm-12'
                        value={this.state.element.tin}
                        viewMode='NEW'
                        // onAfterStateChange={() => {
                        //    // this.checkCeidgExists();
                        //     this.checkAgreementAlreadySent()}}
                        //onAfterStateChange={this.props.formType === 'SECOND' ? this.checkAgreementAlreadySent() : null}
                        validator={this.validator}
                        validators='required|nip'
                        onChange={this.handleChange}
                        required
                        renderRequired
                    />
                      {/* {this.state.nipVerificationLoading === true || this.state.element.tin === '' || this.state.element.tin.length < 10? null : <MenuItemIcon
                        alt={"Weryfikacja numeru NIP"}
                        className={`nip-verify-icon`}
                        iconSvg={this.state.nipVerified === true ? 'ico_verify_success' : 'ico_verify_error'}
                    />
                    }


                    {this.state.nipVerificationLoading === true ? <span className='grey-verified-label'>{t('autoRegistration.tinVerificationLoading')}</span> : this.state.element.tin === '' ? null :
                        this.state.nipVerified === true ? <span className='green-verified-label'>{t('autoRegistration.tinVerifiedSuccess')}</span> : this.state.element.tin.length > 9 ?
                            <span className='red-verified-label'>{t('autoRegistration.tinVerifiedError')}</span> : null} */}

                    {/* {this.state.agreementVerificationLoading === true || this.state.element.tin === '' || this.state.element.tin.length < 10 ? null : <MenuItemIcon
                        alt={"Weryfikacja wysyłki regulaminów"}
                        className={`nip-verify-icon`}
                        iconSvg={this.state.nipSentVerified === true ? 'ico_verify_success' : 'ico_verify_error'}
                    />
                    }


                    {this.state.agreementVerificationLoading === true ? <span className='grey-verified-label'>{t('autoRegistration.agreementVerificationLoading')}</span> : this.state.element.tin === '' ? null :
                        this.state.nipSentVerified === true ? <span className='green-verified-label'>{t('autoRegistration.agreementVerifiedSuccess')}</span> : this.state.element.tin.length > 9 ?
                            <span className='red-verified-label'>{t('autoRegistration.agreementVerifiedError')}</span> : null} */}

                {/* </div> */}
               <div className='row' style={{marginLeft:'0px'}}>
                
                </div>
                {/* <div className='col-xl-6 col-lg-6 col-md-6 col-sm-6 '> */}
                <InputTextComponent
                    id='ownerEmail'
                    name='ownerEmail'
                    //label={t('autoRegistration.email') + "Czy ma byc automatycznie uzupelniany z encji w eboku ten na ktory wyslano regulaminy?"}
                    label={t('autoRegistration.bankRegistrationEmail') }
                        colClass='col-xl-4 col-lg-4 col-md-6 col-sm-12'
                    value={this.state.element.ownerEmail}
                    viewMode='NEW'
                    validator={this.validator}
                    validators='required|email'
                    onChange={this.handleChange}
                    required
                    renderRequired
                />
                {/* </div> */}
               
                


                <div className='row footer-buttons'>
                    {this.renderBackButton(0)}
                    {this.renderNextButton(1)}
                    {/* {this.renderNextButton(2)} */}
                </div>
            </DivContainer>
        );
    }

    // checkCeidgExists() {
    //     const { tin } = this.state.element;
    //     if (tin !== null && tin !== undefined) {
    //         if (tin.length >= 10 && tin.length < 12) {
    //             this.setState({ nipVerificationLoading: true })
    //             this.autoRegistrationService.verifyTin(tin).then((response) => {
    //                 if (response !== null) {
    //                     if(response === true){

    //                     } else {
    //                         this.showErrorMessage("Błędny NIP")
    //                     }
    //                     this.setState({ nipVerified: response, nipVerificationLoading: false })
    //                 }
    //             }).catch((error) => {
    //                 this.showErrorMessage("Błąd weryfikacji NIPu")
    //                 this.setState({ nipVerified: false, nipVerificationLoading: false })
    //             })
    //         } else {
    //             this.setState({ nipVerified: false, nipVerificationLoading: false })
    //         }
    //     } else {
    //         this.setState({ nipVerified: false, nipVerificationLoading: false })
    //     }

    // }

    // checkAgreementAlreadySent() {
    //     const { tin } = this.state.element;
    //     if (tin !== null && tin !== undefined) {
    //         if (tin.length >= 10 && tin.length < 12) {
    //             this.setState({ agreementVerificationLoading: true })
    //             this.autoRegistrationService.verifyClientAgreementSent(tin).then((response) => {
    //                 if (response !== null) {
    //                     if(response.sent === false){
    //                         this.showErrorMessage("Regulaminy nie")
    //                     } else{
    //                         this.setState({ nipSentVerified: response.sent, agreementSentDate: response.date, agreementVerificationLoading: false })

    //                     }
    //                   //  this.setState((prevState) => ({ nipSentVerified: response.sent, agreementSentDate: response.date, agreementVerificationLoading: false, element: {...prevState.element, ownerEmail: response.email} }));
    //                 }
    //             }).catch((error) => {
    //                 this.showErrorMessage("Błąd weryfikacji NIPu")
    //                 this.setState({ nipSentVerified: false, agreementSentDate: undefined, agreementVerificationLoading: false })
    //             })
    //         } else {
    //             this.setState({ nipSentVerified: false, agreementSentDate: undefined, agreementVerificationLoading: false })
    //         }
    //     } else {
    //         this.setState({ nipSentVerified: false, agreementSentDate: undefined, agreementVerificationLoading: false })
    //     }

    // }

    // checkAgreementAlreadySent() {
    //     if (this.state.isAgreementChecked || (this.state.agreementSentDate !== undefined && this.state.nipSentVerified !== undefined)) {
    //         return;
    //     }
    
    //     const { tin } = this.state.element;
    //     this.autoRegistrationService.verifyClientAgreementSent(tin).then((response) => {
    //         if (response !== null && response.sent === true) {
    //             this.setState({
    //                 nipSentVerified: response.sent,
    //                 agreementSentDate: response.date,
    //                 agreementVerificationLoading: false,
    //                 isAgreementChecked: true
    //             });
    //         } else {
    //             this.setState({ isAgreementChecked: true });
    //         }
    //     }).catch((error) => {
    //         this.showErrorMessage("Błąd weryfikacji");
    //         this.setState({
    //             nipSentVerified: false,
    //             agreementSentDate: undefined,
    //             agreementVerificationLoading: false,
    //             isAgreementChecked: true
    //         });
    //     });
    // }

    renderSecondPage() {
        const { t } = this.props;
        this.state.element.ownerPhoneCode =
            this.state.element.ownerPhoneCode === undefined ? this.state.telephoneCodeOptions[0] : this.state.element.ownerPhoneCode;

        // if (!this.state.isAgreementChecked) {
        //     this.checkAgreementAlreadySent();
        // }

        return (
            <DivContainer colClass='row gutter-x-24'>
                {/* {this.state.flatRateFarmerDialogVisible ?
                    <Dialog
                        ariaCloseIconLabel={this.translate('dialog.closeDialog')}
                        visible={this.state.flatRateFarmerDialogVisible}
                        className='farmer-statement-dialog'
                        key={`farmer-dialog`}
                        closable={false}
                    >
                        <Card
                            footer={() => {
                                const { t } = this.props;
                                return (
                                    <div className='footer-dialog-button-container'>
                                        <ActionButton
                                            label={t('autoRegistration.farmerConfirm')}
                                            variant='right-button save-button blue'
                                            handleClick={(e) => {
                                                e.preventDefault();
                                                this.handleCloseFlatRateFarmerDialog();
                                            }}
                                        />
                                    </div>
                                );
                            }}
                        >
                            <div className='confirm-dialog-label'>{t('autoRegistration.flatRateFarmerDialogContent1')}</div>
                            <div className='confirm-dialog-label'>{t('autoRegistration.flatRateFarmerDialogContent2')}</div>
                            <div className='confirm-dialog-label'>{t('autoRegistration.flatRateFarmerDialogContent3')}</div>
                        </Card>
                    </Dialog> : null} */}
                
                <div className='header'>{`3. ${t('autoRegistration.agreementSentDate')}`}</div>
                <span className='p-label flex-inputs'>
                    <MenuItemIcon
                        alt=''
                        key={'agreement-sent-date--key'}
                        id={'agreement-sent-date--id'}
                        className={`icon-svg left`}
                        iconSvg={ this.state.agreementSentDate ? 'ico_agreement_active' : 'ico_agreement_inactive' }
                    />
                </span>
                <InputCalendarComponent
                    id='agreementSentDate'
                    name='agreementSentDate'
                    colClass='col-xl-4 col-lg-4 col-md-4 col-sm-12'
                    value={this.state.agreementSentDate}
                    viewMode='VIEW'
                    validator={this.validator}
                    validators='not_required'
                    onChange={this.handleChange}
                    iconSide='right'
                    iconSize='m'
                    disabled={true}
                />

                <div className='header'>{`4. ${t('autoRegistration.companyData')}`}</div>
                <div className='row'>
                    <InputTextComponent
                        id='companyName'
                        name='companyName'
                        label={t('profile.companyName')}
                        colClass='col-md-3 col-sm-12'
                        value={this.state.element.companyName}
                        viewMode={'VIEW'}
                        validator={this.validator}
                        validators='required'
                        onChange={this.handleChange}
                    />
                    <InputTextComponent
                        id='activeNip'
                        name='activeNip'
                        label={"Działalność aktywna"}
                        colClass='col-md-4 col-sm-12'
                        value={'TAK'}
                        viewMode='VIEW'
                        validator={this.validator}
                        validators='not_required'
                        onChange={this.handleChange}
                        iconSide='right'
                        iconSize='m'
                    />
                    <InputTextComponent
                        id='tin'
                        name='tin'
                        label={t('profile.tin')}
                        colClass='col-md-3 col-sm-12'
                        value={this.state.element.tin}
                        viewMode={'VIEW'}
                        validator={this.validator}
                        validators='required'
                        onChange={this.handleChange}
                    />
                    {this.state.element.customerDataChange === false ? (
                        <InputTextComponent
                            id='companyAddress'
                            name='companyAddress'
                            label={t('autoRegistration.address')}
                            colClass='col-md-3 col-sm-12'
                            value={`${this.state.element.fullAddress.street
                                ? this.state.element.fullAddress.street
                                : this.state.element.fullAddress.city
                                } ${this.state.element.fullAddress.flatNumber
                                    ? `${this.state.element.fullAddress.streetNumber}/${this.state.element.fullAddress.flatNumber}`
                                    : this.state.element.fullAddress.streetNumber
                                } ${this.state.element.fullAddress.postCode} ${this.state.element.fullAddress.city} ${this.state.element.fullAddress.provinceId
                                    ? `woj. ${this.state.provinceOptions
                                        .find((el) => el.petraId === this.state.element.fullAddress.provinceId)
                                        ?.name?.toUpperCase() ?? ''
                                    }`
                                    : ''
                                }`}
                            viewMode={'VIEW'}
                            validator={this.validator}
                            validators='required'
                            onChange={this.handleChange}
                        />
                    ) : null}
                    <InputTextComponent
                        id='email'
                        name='email'
                        label={t('autoRegistration.email')}
                        colClass='col-md-3 col-sm-12'
                        value={this.state.element.email}
                        viewMode={'VIEW'}
                        validator={this.validator}
                        validators='required'
                        onChange={this.handleChange}
                    />
                    {this.state.element.customerDataChange === true ? (
                        <div className='row other-address'>
                            <InputTextComponent
                                id='fullAddress.city'
                                name='city'
                                stateField='element.fullAddress'
                                label={t('address.town')}
                                colClass='col-md-4 col-sm-12'
                                value={this.state.element.fullAddress.city}
                                viewMode='EDIT'
                                validator={this.validator}
                                validators='required'
                                onChange={this.handleChange}
                                required
                                renderRequired
                            />
                            <InputTextComponent
                                id='fullAddressStreet'
                                name='street'
                                stateField='element.fullAddress'
                                label={t('address.street')}
                                colClass='col-md-4 col-sm-12'
                                value={this.state.element.fullAddress.street}
                                viewMode='EDIT'
                                validator={this.validator}
                                validators='not_required'
                                onChange={this.handleChange}
                            />
                            <InputTextComponent
                                id='fullAddressStreetNumber'
                                name='streetNumber'
                                stateField='element.fullAddress'
                                label={t('address.streetNumber')}
                                colClass='col-md-2 col-sm-6'
                                value={this.state.element.fullAddress.streetNumber}
                                viewMode='EDIT'
                                validator={this.validator}
                                validators='required'
                                onChange={this.handleChange}
                                required
                                renderRequired
                            />
                            <InputTextComponent
                                id='fullAddressFlatNumber'
                                name='flatNumber'
                                stateField='element.fullAddress'
                                label={t('address.flatNumber')}
                                colClass='col-md-2 col-sm-6'
                                value={this.state.element.fullAddress.flatNumber}
                                viewMode='EDIT'
                                validator={this.validator}
                                validators='not_required'
                                onChange={this.handleChange}
                            />
                            <div className='col-12'></div>
                            <InputTextComponent
                                id='fullAddressPostCode'
                                name='postCode'
                                stateField='element.fullAddress'
                                label={t('address.postCode')}
                                colClass='col-md-4 col-sm-12'
                                value={this.state.element.fullAddress.postCode}
                                viewMode='EDIT'
                                validator={this.validator}
                                validators='required|zipcode'
                                onChange={this.handleChange}
                                required
                                renderRequired
                            />
                            <InputTextComponent
                                id='fullAddressPostOffice'
                                name='postOffice'
                                stateField='element.fullAddress'
                                label={t('address.postOffice')}
                                colClass='col-md-4 col-sm-12'
                                value={this.state.element.fullAddress.postOffice}
                                viewMode='EDIT'
                                validator={this.validator}
                                validators='required'
                                onChange={this.handleChange}
                                required
                                renderRequired
                            />
                            <InputDropdownComponent
                                id='fullAddressProvince'
                                name='provinceId'
                                stateField='element.fullAddress'
                                label={t('address.voivodeship')}
                                colClass='col-md-4 col-sm-12'
                                value={this.state.element.fullAddress.provinceId}
                                enumMode={true}
                                viewMode='NEW'
                                validator={this.validator}
                                validators='required'
                                options={this.state.provinceOptions}
                                optionValue={'petraId'}
                                onChange={this.handleChange}
                                dataKey='petraId'
                                optionLabel='name'
                                required
                                renderRequired
                            />
                        </div>
                    ) : null}

                    {/* <InputCheckboxComponent
                        id={'companyAuthorized'}
                        name='companyAuthorized'
                        label={t('autoRegistration.companyAuthorizedMessage')}
                        stateField='element'
                        labelOnRight
                        value={this.state.element.companyAuthorized}
                        validator={this.validator}
                        onChange={this.handleChange}
                        viewMode={'EDIT'}
                        validators={'required|accepted'}
                        validatorLabel=''
                        labelClassName='p-label'
                        required={true}
                        renderRequired={true}
                        colClass='col-width-auto'
                    /> */}
                    {/* oswiadczenie rolnikow ryczałtowych - flat rate farmers */}

                    {/* <div className='farmers'> <span className='icon-svg left-label red-star '>*</span>Oświadczam, że</div> */}
                    {/* <div className='flat-rate-farmer-ratiobuttons'>
                        <InputRadioButtonComponent
                            id='flatRateFarmer'
                            name='flatRateFarmer'
                            label={t('autoRegistration.flatRateFarmerStatement')}
                            showLabel={false}
                            colClass='col-12'
                            //className='flat-rate-farmer-ratiobuttons'
                            //descriptionClassName='flat-rate-farmer-ratiobuttons'
                            value={this.state.element.flatRateFarmer}
                            viewMode={'EDIT'}
                            labelOnRight
                            onChange={this.handleChange}
                            options={this.state.flatRateFarmerOptions}
                            validator={this.validator}
                            valueLabel='label'
                            valueKey='enumValue'
                            itemColClass={'col-md-12 col-sm-12'}
                            validators='required'
                        />
                    </div> */}
                    <PhoneNumberComponent
                        id='ownerPhone-dialog'
                        nameCode='ownerPhoneCode'
                        namePhoneNumber='ownerPhoneValue'
                        labelCode={t('cards.phoneNumberCode')}
                        labelPhoneNumber={t('autoRegistration.phone')}
                        colClass='col-xl-4 col-lg-4 col-md-8 col-sm-12'
                        phoneCodeValue={this.state.element.ownerPhoneCode}
                        phoneNumberValue={this.state.element.ownerPhoneValue}
                        telephoneCodeOptions={this.state.telephoneCodeOptions}
                        value={this.state.element.ownerPhone}
                        viewMode='EDIT'
                        onChange={this.handleChange}
                        validator={this.validator}
                        renderRequired
                        required={true}
                    />
                    <InputDropdownComponent
                        id='companyBusiness'
                        name='companyBusiness'
                        label={t('autoRegistration.business')}
                        colClass='col-md-4 col-sm-12'
                        value={this.state.element.companyBusiness}
                        viewMode='NEW'
                        validator={this.validator}
                        validators='required'
                        options={this.state.companyBusinessOptions}
                        onChange={this.handleChange}
                        dataKey='id'
                        optionLabel='label'
                        required
                        renderRequired
                    />
                    <InputDropdownComponent
                        id='companyStatus'
                        name='companyStatus'
                        label={t('autoRegistration.companyStatus')}
                        colClass='col-md-4 col-sm-12'
                        value={this.state.element.companyStatus}
                        viewMode='NEW'
                        validator={this.validator}
                        validators='required'
                        options={this.state.companyStatusOptions}
                        onChange={this.handleChange}
                        dataKey='id'
                        optionLabel='label'
                        required
                        renderRequired
                    />
                </div>
                <InputRadioButtonComponent
                    id='companyContactAddress'
                    name='companyContactAddress'
                    label={t('profile.address')}
                    colClass='col-md-6 col-sm-12'
                    value={this.state.element.companyContactAddress}
                    viewMode={'EDIT'}
                    labelOnRight
                    onChange={this.handleChange}
                    options={[
                        { enumValue: 'same', label: 'Ten sam' },
                        { enumValue: 'other', label: 'Inny' },
                    ]}
                    validator={this.validator}
                    valueLabel='label'
                    itemColClass={'col-xl-6 col-lg-6 col-md-6 col-sm-6'}
                    validators='required'
                    valueKey='enumValue'
                    required
                    renderRequired
                />
                {this.state.element.companyContactAddress === 'other' ? (
                    <div className='row other-address'>
                        <InputTextComponent
                            id='contactStreet'
                            name='contactStreet'
                            label={t('address.street')}
                            colClass='col-md-4 col-sm-12'
                            value={this.state.element.contactStreet}
                            viewMode='NEW'
                            validator={this.validator}
                            validators='required'
                            onChange={this.handleChange}
                            required
                            renderRequired
                        />
                        <InputTextComponent
                            id='contactNumber'
                            name='contactNumber'
                            label={t('address.houseFlatNumber')}
                            colClass='col-md-4 col-sm-12'
                            value={this.state.element.contactNumber}
                            viewMode='NEW'
                            validator={this.validator}
                            validators='required'
                            onChange={this.handleChange}
                            required
                            renderRequired
                        />
                        <div className='col-12'></div>
                        <InputTextComponent
                            id='contactPostCode'
                            name='contactPostCode'
                            label={t('address.postCode')}
                            colClass='col-md-4 col-sm-12'
                            value={this.state.element.contactPostCode}
                            viewMode='NEW'
                            validator={this.validator}
                            validators='required|zipcode'
                            onChange={this.handleChange}
                            required
                            renderRequired
                        />
                        <InputTextComponent
                            id='contactPostOffice'
                            name='contactPostOffice'
                            label={t('address.town')}
                            colClass='col-md-4 col-sm-12'
                            value={this.state.element.contactPostOffice}
                            viewMode='NEW'
                            validator={this.validator}
                            validators='required'
                            onChange={this.handleChange}
                            required
                            renderRequired
                        />
                    </div>
                ) : null}

                {/* <div className='header'>{`5. ${t('autoRegistration.invoiceType')}`}</div>
                <InputRadioButtonComponent
                    id='invoiceType'
                    name='invoiceType'
                    label={t('autoRegistration.invoiceType')}
                    colClass='col-md-6 col-sm-12'
                    value={this.state.element.invoiceType}
                    viewMode={'EDIT'}
                    labelOnRight
                    showLabel={false}
                    options={this.state.invoiceTypeOptions}
                    validator={this.validator}
                    valueLabel='label'
                    itemColClass={'col-12'}
                    validators='required'
                    valueKey='enumValue'
                    onChange={this.handleChange}
                    description='description'
                    showDescription={true}
                    descriptionClassName='p-radiobutton-label'
                    required
                    renderRequired
                    disabled={true}
                /> */}
                <div className='header'>
                    <div>{`5. ${t('autoRegistration.invoiceFrequency')}`}</div>
                    <div className='description-red'>{t('autoRegistration.invoiceFrequencyInfo')}</div>
                </div>

                <InputRadioButtonComponent
                    id='invoiceFrequency'
                    name='invoiceFrequency'
                    label={t('autoRegistration.invoiceFrequency')}
                    colClass='col-md-6 col-sm-12'
                    value={this.state.element.invoiceFrequency}
                    viewMode={'EDIT'}
                    labelOnRight
                    showLabel={false}
                    options={this.state.invoiceFrequencyOptions}
                    validator={this.validator}
                    valueLabel='label'
                    itemColClass={'col-12'}
                    validators='required'
                    valueKey='enumValue'
                    description='description'
                    onChange={this.handleChange}
                    showDescription={true}
                    htmlDescription={true}
                    descriptionClassName='p-radiobutton-label'
                    required
                    renderRequired
                />
                <div className='row footer-buttons'>
                    {this.renderBackButton(0)}
                    {this.renderNextButton(2)}
                </div>
            </DivContainer>
        );
    }

    renderThirdPage() {
        const { t } = this.props;
        const { cards } = this.state.element;
        return (
            <DivContainer colClass='row'>
                <div className='header'>{`6. ${t('autoRegistration.addFuelCards')}`}</div>
                <ul style={{ paddingLeft: '20px' }}>
                    <li>{t('autoRegistration.addFuelCards1')}</li>
                    <li>{t('autoRegistration.addFuelCards2')}</li>
                    <li>{t('autoRegistration.addFuelCards3')}</li>
                </ul>
                <DivContainer colClass='row'>
                    {cards !== null && cards !== undefined && cards.length > 0
                        ? cards.map((element, index) => {
                            return (
                                <div key={`fuel-card-${index}`} className='p-card'>
                                    <div className='row'>
                                        <div className='row p-card-header'>
                                            <div className='col-6 icon-with-text'>
                                                <img
                                                    src='/images/ico_autoregister_card.svg'
                                                    className='auto-register-ico-menu-card'
                                                    alt='icon card'
                                                />
                                                <div>{`${t('autoRegistration.card')} ${index + 1} ${t('autoRegistration.from')} ${this.state.element.cards.length
                                                    }`}</div>
                                            </div>
                                            <div className='col-6 delete-card-button'>
                                                {index !== 0 ? this.renderDeleteCardButton(index) : null}
                                            </div>
                                        </div>
                                        <div className='p-card-content'>
                                            <FuelCardComponent
                                                idPrefix={index}
                                                element={element}
                                                handleChange={this.handleChange}
                                                validator={this.validator}
                                                stateField={`element.cards[${index}]`}
                                                fuelCardTypeOptions={this.state.fuelCardTypeOptions}
                                                fuelCardAppRoleOptions={this.state.fuelCardAppRoleOptions}
                                                translation={this.translate}
                                                handleFuelCardTypeChange={this.handleFuelCardTypeChange(element)}
                                                phoneCodeOptions={this.state.telephoneCodeOptions}
                                                chosenOfferType={this.state.element.offerType}
                                                cardOptions={this.state.cardOptions}
                                                handleChoosePlasticCardOption={this.handleChoosePlasticCardOption(element)}
                                                vehicleTypeOpt={this.state.vehicleTypeOpt}
                                                bank={true}
                                            />
                                        </div>
                                    </div>
                                </div>
                            );
                        })
                        : null}
                </DivContainer>
                <div className='center-div'>
                    {this.state.element.cards.length < this.state.maxFuelCards ? this.renderAddCardButton() : null}
                </div>
                <div className='row footer-buttons'>
                    {this.renderBackButton(1)}
                    {this.renderNextButton(3)}
                </div>
            </DivContainer>
        );
    }

    vehicleTypeTemplate(data, options) {
        return options.filter(o => o.code === data.vehicleType)[0]?.label;
    }

    renderFourthPage() {
        const { t } = this.props;
        const { cards } = this.state.element;
        const { vehicleTypeOpt } = this.state;
        return (
            <DivContainer colClass='row'>
                <div className='header'>{`7. ${t('autoRegistration.cardsOrderSummary')}`}</div>
                {/* <div className='header-2'>{t('autoRegistration.companyNameInfo')}</div>
                <InputTextComponent
                    id='cardCompanyName'
                    name='cardCompanyName'
                    label={t('profile.companyName')}
                    colClass='col-md-6 col-lg-4 col-sm-12'
                    value={this.state.element.cardCompanyName}
                    viewMode='NEW'
                    validator={this.validator}
                    validators='required|max:25'
                    max={25}
                    onChange={this.handleChange}
                    required
                    renderRequired
                    keyfilter={/^[^"]*$/i}
                />
                 <div className='header-2' style={{marginTop: '10px'}}>{t('autoRegistration.agreementRegisterDateInfo')}</div>
                <InputCalendarComponent
                   id='signAgreementDate'
                    name='signAgreementDate'
                    label={"Data podpisania umowy - nowe pole"}
                   // dateFormatMoment='DD-MM-YYYY'
                    dateFormatMoment='DD-MM-YYYY HH:mm:ss'
                    colClass='col-xl-4 col-lg-4 col-md-4 col-sm-6'
                    value={this.state.element.signAgreementDate}
                    viewMode={'EDIT'}
                    showIcon
                    validator={this.validator}
                    onChange={this.handleChange}
                    maxDate= {new Date()}
                /> */}


    <DivContainer colClass='row'>
                    <DivContainer colClass='row'>
                        <DataTable
                            id='dataTable'
                            key='data-table'
                            emptyMessage={this.translate('list.empty')}
                            className='p-datatable-responsive'
                            responsive
                            value={cards}
                            sortOrder={-1}
                            rows={cards.length}
                            lazy={this.props.lazy}
                            rowClassName={this.props.rowClassName}
                        >
                            <Column field='cardNumber' header={t('autoRegistration.lp')} />
                            <Column field='registrationNumber' header={t('autoRegistration.RegistrationNumber')} />
                            <Column body={(el) => this.vehicleTypeTemplate(el, vehicleTypeOpt)} header={t('autoRegistration.vehicleType')} />
                            <Column field='fuelCardName' header={t('autoRegistration.fuelCardName')} />
                            <Column field='hybridCardId' header={t('autoRegistration.hybridCardId')} />
                            <Column body={(el) => t(`EcCardKind.${el.fuelCardType}`)} header={t('autoRegistration.fuelCardType')} />
                            {/* <Column
                                header={t('autoRegistration.cost')}
                                body={(list) => {
                                    return `${list.cost} ${t('currency.pln')}`;
                                }}
                            /> */}
                        </DataTable>
                    </DivContainer>
                </DivContainer>

<div className='header'>{`8. Załącz wymagane pliki`}</div>

<div className='p-card-bank-attachments col-12'>
                    <div className='col-4'>
                        <div className='header-2-custom-style' >{t('autoRegistration.emailStatementScanAttachment')}</div>
                        <InputFileChooseComponent
                            id='emailStatementFile'
                            name='emailStatementFile'
                            colClass={
                                this.state.emailStatementFile
                                    ? 'autoregistration-upload-file col-12'
                                    : 'autoregistration-upload-file-empty col-12'
                            }
                            multiple={false}
                            file={this.state.emailStatementFile}
                            showLabel={false}
                            viewMode='NEW'
                            label='Oświadczenie o przekazaniu adresu email'
                            onChange={(a,b,c,d,e) => this.handleChange(a,b,c,d,e)}
                            validator={this.validator}
                            itemLabel='fileName'
                            maxFileSize={2000000}
                            maxFileCount={1}
                            validateViewMode
                            validators='required'
                            browseButton={
                                !this.state.emailStatementFile ? (
                                    <div className='file-label'>
                                        <img
                                            alt={t('order-card.uploadIconLabel')}
                                            src='/images/ico_drag_file.svg'
                                            className='file-label-icon'
                                        />
                                        <div className='file-label-text'>{t('order-card.uploadIconLabel')}</div>
                                    </div>
                                ) : null
                            }
                            dragNdrop={true}
                            stateField=''
                            onAfterStateChange={this.handleAfterFileChange}
                            clickable={true}
                        />
                    </div>
                    <div className='col-4'>
                        <div className='header-2-custom-style' >{t('autoRegistration.registerStatementScanAttachment')}</div>
                        <InputFileChooseComponent
                            id='registrationStatementFile'
                            name='registrationStatementFile'
                            colClass={
                                this.state.registrationStatementFile
                                    ? 'autoregistration-upload-file col-12'
                                    : 'autoregistration-upload-file-empty col-12'
                            }
                            multiple={false}
                            file={this.state.registrationStatementFile}
                            showLabel={false}
                            viewMode='NEW'
                            label='Oświadczenie rejestracyjne klienta'
                            onChange={this.handleChange}
                            validator={this.validator}
                            itemLabel='fileName'
                            maxFileSize={2000000}
                            maxFileCount={1}
                            validateViewMode
                            validators='required'
                            browseButton={
                                !this.state.registrationStatementFile ? (
                                    <div className='file-label'>
                                        <img
                                            alt={t('order-card.uploadIconLabel')}
                                            src='/images/ico_drag_file.svg'
                                            className='file-label-icon'
                                        />
                                        <div className='file-label-text'>{t('order-card.uploadIconLabel')}</div>
                                    </div>
                                ) : null
                            }
                            dragNdrop={true}
                            stateField=''
                            onAfterStateChange={this.handleAfterFileChange}
                            clickable={true}
                        /> </div>
                    <div className='col-4'>
                        <div className='header-2-custom-style' >{t('autoRegistration.krsScanAttachment')}</div>
                        <InputFileChooseComponent
                            id='krsFile'
                            name='krsFile'
                            colClass={
                                this.state.krsFile
                                    ? 'autoregistration-upload-file col-12'
                                    : 'autoregistration-upload-file-empty col-12'
                            }
                            multiple={false}
                            file={this.state.krsFile}
                            showLabel={false}
                            viewMode='NEW'
                            label='Załącznik KRS/CEIDG'
                            onChange={this.handleChange}
                            validator={this.validator}
                            itemLabel='fileName'
                            maxFileSize={2000000}
                            maxFileCount={1}
                            validateViewMode
                            validators='required'
                            browseButton={
                                !this.state.krsFile ? (
                                    <div className='file-label'>
                                        <img
                                            alt={t('order-card.uploadIconLabel')}
                                            src='/images/ico_drag_file.svg'
                                            className='file-label-icon'
                                        />
                                        <div className='file-label-text'>{t('order-card.uploadIconLabel')}</div>
                                    </div>
                                ) : null
                            }
                            dragNdrop={true}
                            stateField=''
                            onAfterStateChange={this.handleAfterFileChange}
                            clickable={true}
                        /></div>


                </div>

{/* <div className='header'>{`11. Dane pracownika banku??????`}</div>

<div className='row other-address'>
                            <InputTextComponent
                                id='bankEmployeeFirstame'
                                name='bankEmployeeFirstame'
                                stateField='element'
                                label={'Imię'}
                                colClass='col-md-6 col-sm-12'
                                value={this.state.element.bankEmployeeFirstame}
                                viewMode='NEW'
                                validator={this.validator}
                                validators='required'
                                onChange={this.handleChange}
                                required
                                renderRequired
                            />
                            <InputTextComponent
                                id='bankEmployeeLastname'
                                name='bankEmployeeLastname'
                                stateField='element'
                                label={'Nazwisko'}
                                colClass='col-md-6 col-sm-12'
                                value={this.state.element.bankEmployeeLastname}
                                viewMode='NEW'
                                validator={this.validator}
                                validators='required'
                                onChange={this.handleChange}
                                renderRequired
                            />
                            <InputTextComponent
                                id='bankEmployeePosition'
                                name='bankEmployeePosition'
                                stateField='element'
                                label={'Stanowisko'}
                                colClass='col-md-4 col-sm-12'
                                value={this.state.element.bankEmployeePosition}
                                viewMode='NEW'
                                validator={this.validator}emailStatementScanAttachment
                                validators='required'
                                onChange={this.handleChange}
                                required
                                renderRequired
                            /> 
                            <InputTextComponent
                                id='bankEmployeeEmail'
                                name='bankEmployeeEmail'
                                stateField='element'
                                label={'Adres e-mail'}
                                colClass='col-md-4 col-sm-6'
                                value={this.state.element.bankEmployeeEmail}
                                viewMode='NEW'
                                validator={this.validator}
                                validators='required'
                                onChange={this.handleChange}
                                required
                                renderRequired
                            />
                            <InputTextComponent
                                id='bankEmployeePhone'
                                name='bankEmployeePhone'
                                stateField='element'
                                label={'Numer telefonu'}
                                colClass='col-md-4 col-sm-6'
                                value={this.state.element.bankEmployeePhone}
                                viewMode='NEW'
                                validator={this.validator}
                                validators='required'
                                onChange={this.handleChange}
                                required
                                renderRequired
                            />
                            
                            </div> */}



                <div className='header'>{`9. ${t('autoRegistration.checkApprovals')}`}</div>
                <DivContainer>
                    <div className='check-all'>
                        <InputCheckboxComponent
                            id='checkAll'
                            name='checkAll'
                            label={t('autoRegistration.checkAll')}
                            labelOnRight
                            value={this.state.checkAll}
                            onChange={this.state.checkAll ? this.uncheckAll : this.setCheckAll}
                            validator={this.validator}
                            viewMode='NEW'
                            validators='not_required'
                            colClass='col-12'
                        />
                    </div>
                    {this.state.approvals.map((approval, index) => {
                        const label = approval.contents
                            .map((str) => {
                                return str.type === 'TRANSLATE'
                                    ? t(`${str.content}`)
                                    : `<a href="${str.linkUrl}" target="_blank">${t(str.linkLabel)}</a> `;
                            })
                            .join('');
                        return (
                            <div>
                                <InputCheckboxComponent
                                    id={`approval-${index}`}
                                    name={`approval-${index}`}
                                    label={label}
                                    labelOnRight
                                    value={this.state.element[`approval-${index}`]}
                                    onChange={this.handleChange}
                                    validator={this.validator}
                                    viewMode='NEW'
                                    validators={!!approval.required ? 'required|accepted' : 'not_required'}
                                    colClass='col-12'
                                    labelClassName='approval-content-title'
                                    required={!!approval.required}
                                    renderRequired={!!approval.required}
                                    validatorLabel=''
                                    onAfterStateChange={() => {
                                        const changedElement = this.state.element;
                                        if (approval.approvalType === 'MARKETING' && approval.checkboxes?.length > 0) {
                                            if (!!this.state.element[`approval-${index}`]) {
                                                this.setCheckAllCheckboxForApproval(approval, index);
                                                changedElement.phoneMarketing = true;
                                                changedElement.emailMarketing = true;
                                            } else {
                                                this.unCheckAllCheckboxForApproval(approval, index);
                                                changedElement.phoneMarketing = false;
                                                changedElement.emailMarketing = false;
                                            }
                                        }

                                        if (approval.petraAgreementId !== null) {
                                            if (!!this.state.element[`approval-${index}`]) {
                                                changedElement.petraAgreements = this.addPetraAgreementId(approval.petraAgreementId);
                                            } else {
                                                changedElement.petraAgreements = this.removePetraAgreementId(approval.petraAgreementId);
                                            }

                                        }

                                        this.setState((prevState) => ({
                                            ...prevState,
                                            checkAll: true,
                                            element: changedElement,
                                        }));
                                    }}
                                />
                                {approval.checkboxes?.length > 0 ?
                                    approval.checkboxes.map((c, cIndex) => {
                                        const cLabel = c.contents !== null && c.contents !== undefined && c.contents.length > 0 ?
                                            c.contents.map((str) => {
                                                return str.type === 'TRANSLATE'
                                                    ? t(`${str.content}`)
                                                    : `<a href="${str.linkUrl}" target="_blank">${t(str.linkLabel)}</a> `;
                                            })
                                                .join('') : t(`${c.content}`);
                                        // const cLabel = t(`${c.content}`)
                                        return (
                                            <div className='marketingCheckboxes'>
                                                <InputCheckboxComponent
                                                    id={`approval-${index}-checkbox-${cIndex}`}
                                                    name={`approval-${index}-checkbox-${cIndex}`}
                                                    label={cLabel}
                                                    labelOnRight
                                                    //className={'marketingCheckboxes'}
                                                    value={this.state.element[`approval-${index}-checkbox-${cIndex}`]}
                                                    onChange={this.handleChange}
                                                    validator={this.validator}
                                                    viewMode='NEW'
                                                    validators={!!approval.required ? 'required|accepted' : 'not_required'}
                                                    colClass='col-12'
                                                    labelClassName='approval-content-title'
                                                    required={!!approval.required}
                                                    renderRequired={!!approval.required}
                                                    validatorLabel=''
                                                    onAfterStateChange={() => {
                                                        const changedElement = this.state.element;
                                                        if (c.type === 'MARKETING_PHONE') {
                                                            if (!!this.state.element[`approval-${index}-checkbox-${cIndex}`]) {
                                                                changedElement.phoneMarketing = true;
                                                                this.setApprovalIfAllCheckboxesChecked(approval, index);
                                                            } else {
                                                                this.unsetApprovalIfAllCheckboxesUnChecked(approval, index);
                                                                changedElement.phoneMarketing = false;
                                                            }
                                                        }
                                                        if (c.type === 'MARKETING_EMAIL') {
                                                            if (!!this.state.element[`approval-${index}-checkbox-${cIndex}`]) {
                                                                changedElement.emailMarketing = true;
                                                                this.setApprovalIfAllCheckboxesChecked(approval, index);
                                                            } else {
                                                                this.unsetApprovalIfAllCheckboxesUnChecked(approval, index);
                                                                changedElement.emailMarketing = false;
                                                            }
                                                        }
                                                        this.setState((prevState) => ({
                                                            ...prevState,
                                                            element: changedElement,
                                                        }));

                                                    }}
                                                />
                                            </div>



                                        )


                                    }) : null

                                }
                            </div>

                        );
                    })}
                </DivContainer>
                <div className='row footer-buttons'>
                    {this.renderBackButton(2)}
                    {this.renderNextButton(4)}
                </div>
            </DivContainer>
        );
    }

    renderFinalPage() {
        const { t } = this.props;
        let success = this.state.errorCode === null || this.state.errorCode === undefined;
        let listCheck = false;
        this.state.element.cards.map((element) => {
            if (element.fuelCardPlastic) {
                listCheck = true;
            }
            return listCheck;
        });
        return (
            <div className='row center'>
                <div className='final-page'>
                    <img src='/images/ico_check.svg' className='auto-register-ico-check' alt='check icon' />
                    <div className='final-header'>
                        {success ? t('autoRegistration.registerTextBank') : t('autoRegistration.registerPendingTextBank')}
                    </div>
                    {success ? <div className='link-header'>{t('autoRegistration.registerLinkTextBank')}</div> : null}
                    <div className='center-div'>{this.renderBackButton()}</div>
                  
                </div>
            </div>
        );
    }
    setCheckAll() {
        const changedElement = this.state.element;
        changedElement.phoneMarketing = true;
        changedElement.emailMarketing = true;
        this.state?.approvals?.forEach((approval, index) => {
            changedElement[`approval-${index}`] = true;
            if (approval.petraAgreementId !== null) {
                if (!!this.state.element[`approval-${index}`]) {
                    changedElement.petraAgreements = this.addPetraAgreementId(approval.petraAgreementId);
                }
            }
            if (approval.checkboxes.length > 0) {
                approval.checkboxes.forEach((c, cIndex) => {
                    changedElement[`approval-${index}-checkbox-${cIndex}`] = true;
                })
            }
        });
        this.setState((prevState) => ({
            ...prevState,
            checkAll: true,
            element: changedElement,
        }));
    }

    setCheckAllCheckboxForApproval(approval, approvalIndex) {
        const changedElement = this.state.element;
        changedElement.phoneMarketing = true;
        changedElement.emailMarketing = true;
        // let appr = this.state.element[`approval-${approvalIndex}`];

        approval.checkboxes.forEach((c, cIndex) => {
            changedElement[`approval-${approvalIndex}-checkbox-${cIndex}`] = true;
        })

        this.setState((prevState) => ({
            ...prevState,
            element: changedElement,
        }));
    }
    unCheckAllCheckboxForApproval(approval, approvalIndex) {
        const changedElement = this.state.element;
        changedElement.phoneMarketing = false;
        changedElement.emailMarketing = false;
        //  let appr = this.state.element[`approval-${approvalIndex}`];

        approval.checkboxes.forEach((c, cIndex) => {
            changedElement[`approval-${approvalIndex}-checkbox-${cIndex}`] = false;
        })


        this.setState((prevState) => ({
            ...prevState,
            element: changedElement,
        }));
    }
    setApprovalIfAllCheckboxesChecked(approval, approvalIndex) {
        const changedElement = this.state.element;
        /*     let counter = 0;
                approval.checkboxes.forEach((c, cIndex) => {
                    if( changedElement[`approval-${approvalIndex}-checkbox-${cIndex}`] === true){
                        counter += 1;
                    }
                });
    
                if(counter ===  approval.checkboxes.length){
                    changedElement[`approval-${approvalIndex}`] = true;
                } */
        changedElement[`approval-${approvalIndex}`] = true;
        this.setState((prevState) => ({
            ...prevState,
            element: changedElement,
        }));
    }
    unsetApprovalIfAllCheckboxesUnChecked(approval, approvalIndex) {
        const changedElement = this.state.element;
        let counter = 0;
        approval.checkboxes.forEach((c, cIndex) => {
            if (changedElement[`approval-${approvalIndex}-checkbox-${cIndex}`] === false) {
                counter += 1;
            }
        });

        if (counter === approval.checkboxes.length) {
            changedElement[`approval-${approvalIndex}`] = false;
        }

        this.setState((prevState) => ({
            ...prevState,
            element: changedElement,
        }));
    }

    addPetraAgreementId(petraAgreementId) {
        let modifiedList = this.state.element.petraAgreements;;
        if (modifiedList.filter(el => el === petraAgreementId).length === 0) {
            modifiedList.push(petraAgreementId);
        }
        return modifiedList;
    }
    removePetraAgreementId(petraAgreementId) {
        let modifiedList = this.state.element.petraAgreements;
        if (modifiedList.filter(el => el === petraAgreementId).length > 0) {
            let afterRemove = modifiedList.filter(el => el !== petraAgreementId);
            return afterRemove;
        }
        else return modifiedList;

    }

    uncheckAll() {
        const changedElement = this.state.element;
        changedElement.phoneMarketing = false;
        changedElement.emailMarketing = false;
        this.state?.approvals?.forEach((approval, index) => {
            changedElement[`approval-${index}`] = false;
            if (approval.petraAgreementId !== null) {
                if (!this.state.element[`approval-${index}`]) {
                    changedElement.petraAgreements = this.removePetraAgreementId(approval.petraAgreementId);
                }
            }
            if (approval.checkboxes.length > 0) {
                approval.checkboxes.forEach((c, cIndex) => {
                    changedElement[`approval-${index}-checkbox-${cIndex}`] = false;
                })
            }
        });
        this.setState((prevState) => ({
            ...prevState,
            checkAll: false,
            element: changedElement,
        }));
    }

    checkCheckAll() {
        let isUnchecked;
        const changedElement = this.state.element;
        this.state?.approvals?.forEach((approval, index) => {
            if (!changedElement[`approval-${index}`]) {
                isUnchecked = true;
                return;
            }
        });

        if (this.state.checkAll && isUnchecked) {
            this.setState((prevState) => ({
                ...prevState,
                checkAll: false,
            }));
        }
    }

    renderBackButton(pageNumber) {
        const { t } = this.props;
        return (
            <ActionButton
                label={
                    this.state.pageIndex === 0 || this.props.formType === 'FIRST'
                        ? t('details.cancel')
                        : this.state.pageIndex === 4
                            ? this.state.errorCode === undefined
                                ? t('autoRegistration.registerLoginBank')
                                : t('autoRegistration.registerCloseBank')
                            : t('details.back')
                }
                variant={this.state.pageIndex === 4 ? 'back-button blue' : 'back-button white m'}
                colClass=''
                href='/#/bank-start-page'
                handleClick={
                    this.state.pageIndex !== 0 && this.state.pageIndex !== 4
                        ? (e) => {
                            e.preventDefault();
                            this.setState({ pageIndex: pageNumber });
                            this.scrollToTop();
                        }
                        : null
                }
            />
        );
    }

    renderToLoginButton() {
        const { t } = this.props;
        return <ActionButton label={t('autoRegistration.returnToLogin')} variant='to-login-button white m' href='/#/start' />;
    }

    renderToFormChooseButton() {
        const { t } = this.props;
        return <ActionButton label={'Powrót do wyboru formularza'} variant='to-login-button white m' //onClick={()=> this.setState({formChoosen : undefined})}  
            href='/#/bank-start-page'
        />;
    }

    renderSaveButton() {
        const { element } = this.state;
        const nip = this.normalizeNip();
        let prepareElementBeforeSend = { bankName: element.bankName, tin: nip, ownerEmail: element.ownerEmail };
        return (
            <ActionButton
                label={'Wyślij formularz'}
                variant='next-button blue m'
                colClass=''
                handleClick={(e) => {
                    e.preventDefault();
                    this.blockUi();
                    this.handleFirstFormSubmit(e, prepareElementBeforeSend);

                }}
            />
        );
    }

    renderNextButton(pageNumber) {
        const { t } = this.props;
        let label;
        switch (this.state.pageIndex) {
            case 0:
                label = `${t('details.forward')} - ${t('autoRegistration.settlemetData')}`;
                break;
            case 1:
                label = `${t('details.forward')} - ${t('autoRegistration.cardType')}`;
                break;
            case 2:
                label = `${t('details.forward')} - ${t('autoRegistration.summary')}`;
                break;
            case 3:
                label = t('autoRegistration.placeOrder');
                break;
            default:
                label = t('details.forward');
                break;
        }
        return (
            <ActionButton
                label={label}
                variant='next-button blue m'
                colClass=''
                handleClick={(e) => {
                    e.preventDefault();
                    if (this.state.pageIndex === 1 && this.state.element.flatRateFarmer !== undefined) {
                        if (this.state.element.flatRateFarmer === 'SELF_EMPLOYED') {
                            this.blockUi();
                            this.handleFormSubmit(e, pageNumber);
                        } else if (this.state.element.flatRateFarmer === 'FLAT_RATE_FARMER') {
                            this.handleFormSubmit(e, pageNumber - 1);
                        }
                    } else {
                        this.blockUi();
                        this.handleFormSubmit(e, pageNumber);
                    }
                }}
                //disabled={this.state.pageIndex === 0 && (this.state.nipSentVerified === false || this.state.nipVerified === false)}
            />
        );
    }

    // renderNextButton(pageNumber) {
    //     const {t} = this.props;
    //     let label = `Wypełnij formularz rejestracyjny`;

    //     return (
    //         <ActionButton
    //             label={label}
    //             variant='next-button blue m'
    //             colClass=''
    //             handleClick={(e) => {
    //                 e.preventDefault();
    //                 if(this.state.pageIndex === 1 && this.state.element.flatRateFarmer !== undefined){
    //                     if(this.state.element.flatRateFarmer === 'SELF_EMPLOYED' ){
    //                         this.blockUi();
    //                         this.handleFormSubmit(e, pageNumber);
    //                     } else if(this.state.element.flatRateFarmer === 'FLAT_RATE_FARMER' ){
    //                         this.handleFormSubmit(e, pageNumber-1);
    //                     }
    //                 } else {
    //                     this.blockUi();
    //                     this.handleFormSubmit(e, pageNumber);
    //                 }
    //             }}
    //         />
    //     );
    // }

    renderSendTermsButton(pageNumber) {
        const { t } = this.props;

        return (
            <ActionButton
                label={"Wyślij dane"}
                variant='next-button blue m'
                colClass=''
                handleClick={(e) => {
                    e.preventDefault();
                    if (this.state.pageIndex === 1 && this.state.element.flatRateFarmer !== undefined) {
                        if (this.state.element.flatRateFarmer === 'SELF_EMPLOYED') {
                            this.blockUi();
                            this.handleFormSubmit(e, pageNumber);
                        } else if (this.state.element.flatRateFarmer === 'FLAT_RATE_FARMER') {
                            this.handleFormSubmit(e, pageNumber - 1);
                        }
                    } else {
                        this.blockUi();
                        this.handleFormSubmit(e, pageNumber);
                    }
                }}
            />
        );
    }

    handleOpenFlatRateFarmerDialog() {
        this.setState({ flatRateFarmerDialogVisible: true });
    }
    handleCloseFlatRateFarmerDialog() {
        this.setState({ flatRateFarmerDialogVisible: false });
    }

    handleFirstFormSubmit(e, el) {
        const { t } = this.props;
        if (this.props.formType === 'FIRST') {
            if (this.validator.allValid()) {
                this.autoRegistrationService
                    .registrationByBankFirstForm(el)
                    .then((response) => {
                        if (!!response.emailError || !!response.tinError || response.ecError !== null) {
                            if (!!response.emailError) {
                                this.showErrorMessage(t(`error.getRegistrationEmailErrorCode.${response.emailError}`));
                            }
                            if (!!response.tinError) {
                                this.showErrorMessage(t(`error.getRegistrationCustomerErrorCode.${response.tinError}`));
                            }
                            if (response.ecError !== null) {
                                this.showErrorMessage(t('autoRegistration.errorSendBankClientAgreementForm'));
                            }
                        } else {
                            this.afterAddSuccess(t('autoRegistration.successSentBankClientAgreementForm'), '/#/bank-start-page')
                        }
                        this.unblockUi()
                    })
                    .catch((err) => {
                        this.showErrorMessage(t('autoRegistration.bankPreRegistrationError'));
                        this.unblockUi()
                    })

            } else {
                this.validator.showMessages();
                this.scrollToError = true;
                this.forceUpdate();
                this.unblockUi();
            }
        }
    }

    handleFormSubmit(event, pageNumber) {
        const { t } = this.props;
        const{element} = this.state;
        element.offerType = 'CASH';
       
        const file1 = this.state.emailStatementFile;
        const file2 = this.state.registrationStatementFile;
        const file3 = this.state.krsFile;
        if (event !== undefined) {
            event.preventDefault();
        }
        if (this.validator.allValid()) {
            this.messages.clear();
            this.validator.hideMessages();
            if (this.state.pageIndex === 1 && this.state.element.flatRateFarmer === 'FLAT_RATE_FARMER') {
                this.handleOpenFlatRateFarmerDialog();
               // this.saveFlatRateFarmerStatement();
            }
            else {
                switch (this.state.pageIndex) {
                    case 0: {
                        this.autoRegistrationService
                            .registrationValidateCustomerAndEmail(this.normalizeNip(), this.state.element?.ownerEmail)
                            .then((response) => {
                                if (!!response.emailErrorCode || !!response.customerErrorCode || !!response.bankClientAgreementsSendError) {
                                    if (!!response.emailErrorCode) {
                                        this.showErrorMessage(t(`error.getRegistrationEmailErrorCode.${response.emailErrorCode}`));
                                    }
                                    if (!!response.customerErrorCode) {
                                        this.showErrorMessage(t(`error.getRegistrationCustomerErrorCode.${response.customerErrorCode}`));
                                    }
                                    if(!!response.bankClientAgreementsSendError){
                                        this.showErrorMessage(t('autoRegistration.agreementVerifiedError'));
                                    }
                                } else if (response?.customers.length === 1 && response?.emailValidated) {
                                  //  this.checkAgreementAlreadySent()
                                    const customer = response?.customers[0];
                                    this.setState(
                                        (prevState) => ({
                                            prevState,
                                            pageIndex: pageNumber,
                                            nipSentVerified: !response.bankClientAgreementsSendError,
                                            agreementSentDate: response.bankClientAgreementsSentDate,
                                            agreementVerificationLoading: false,
                                            isAgreementChecked: true,
                                            element: {
                                                ...prevState.element,
                                                fullAddress: {
                                                    city: customer.fullAddress.city,
                                                    street: customer.fullAddress.street,
                                                    streetNumber: customer.fullAddress.streetNumber,
                                                    flatNumber: customer.fullAddress.flatNumber,
                                                    postCode: customer.fullAddress.postCode,
                                                    postOffice: customer.fullAddress.postOffice,
                                                    provinceId: customer.fullAddress.provinceId,
                                                },
                                                companyName: customer.fullName,
                                                email: customer.email,
                                                existsInOtherRole: customer.existsInOtherRole,
                                                regon: customer.regon,
                                                cbkId: customer.cbkId,
                                                customerDataChange: customer.customerDataChange,
                                            },
                                        }),
                                        this.registrationStart()
                                    );
                                } else if (response?.customers.length > 1 && response?.emailValidated) {
                                    this.setState({
                                        selectCustomerDialogVisible: true,
                                        customerOptions: response.customers,
                                        nipSentVerified: !response.bankClientAgreementsSendError,
                                        agreementSentDate: response.bankClientAgreementsSentDate,
                                        agreementVerificationLoading: false,
                                        isAgreementChecked: true
                                    });
                                }
                                this.unblockUi();
                            });
                        return;
                    }
                    case 1:
                        this.addFuelCard(this.state.element.ownerPhoneCode, this.state.element.ownerPhoneValue, 'ADMIN');
                        break;
                    case 2:
                        this.state.element.cards.forEach((el) => {
                            if (
                                el.phoneNumberCode !== undefined &&
                                el.phoneNumberCode !== null &&
                                el.phoneNumberValue !== undefined &&
                                el.phoneNumberValue !== null &&
                                el.phoneNumberValue !== ''
                            ) {
                                el.phoneNumber = el.phoneNumberCode.code + el.phoneNumberValue;
                            }
                        });
                        break;
                    case 3:
                        //this.saveFlatRateFarmerStatement();
                        this.completeRegistration(file1, file2, file3);
                        return;
                    default:
                        break;
                }
            }




            this.blockUi(this.setState({ pageIndex: pageNumber }));
            this.scrollToTop();
            this.unblockUi();
        } else {
            this.validator.showMessages();
            this.scrollToError = true;
            this.forceUpdate();
            this.unblockUi();
        }
    }

    renderAddCardButton() {
        const { t } = this.props;
        return (
            <ActionButton
                label={t('autoRegistration.addCard')}
                variant='add-card-button white m'
                handleClick={(e) => {
                    e.preventDefault();
                    this.addFuelCard();
                }}
            />
        );
    }

    renderDeleteCardButton(index) {
        const { t } = this.props;
        return (
            <ActionLink
                label={t('autoRegistration.deleteCard')}
                variant='button white-black height-88'
                className='delete-card-button'
                colClass=''
                handleClick={(e) => {
                    e.preventDefault();
                    this.deleteFuelCard(index);
                }}
            />
        );
    }

    addFuelCard(phoneNumberCode, phoneNumberValue, appRole) {    
        let object = {
            uuid: uuidv4(),
            fuelCardType: 'FIRM',
            // fuelCardAppRole: appRole ? appRole : 'DRIVER',
            fuelCardVirtual: true,
            fuelCardPlastic: true,
            phoneNumberCode: undefined, 
            phoneNumberValue: undefined,
            fuelCardName: '',
            registrationNumber: '',
            electromobility: false,
        };
        if (this._isMounted) {
            this.setState((prevState) => {
                const element = prevState.element || {};
                const cards = element.cards ? [...element.cards] : [];
                if (cards.length < prevState.maxFuelCards) {
                    cards.push(object);
                }
                return {
                    element: {
                        ...element,
                        cards: cards,
                    },
                };
            });
        }
    }

    deleteFuelCard(index) {
        if (this._isMounted && this.state.element.cards) {
            let cards = this.state.element.cards;
            cards.splice(index, 1);
            this.setState((prevState) => ({
                element: {
                    ...prevState.element,
                    cards: cards,
                },
            }));
        }
    }

    renderStepsNav() {
        const { t } = this.props;
        const items = [
            { label: t('autoRegistration.paymentMethod') },
            { label: t('autoRegistration.settlemetDataUp') },
            { label: t('autoRegistration.cardTypeUp') },
            { label: t('autoRegistration.summaryUp') },
        ];
        return (
            <div className='col-md-8 col-sm-12'>
                <Steps
                    model={items}
                    activeIndex={this.state.pageIndex}
                    icons
                    activeIconSrc='/images/ico_steps_check.svg'
                    completedIconsSrc='/images/ico_blue_dot_of_doom.svg'
                    nextIconsSrc='/images/ico_steps_next.svg'
                />
            </div>
        );
    }

    handleFuelCardTypeChange(element) {
        if (element) {
            switch (element.fuelCardType) {
                case 'FIRM':
                    element.registrationNumber = '';
                    element.fuelCardName = '';
                    break;
                case 'VEHICLE':
                    element.fuelCardName = '';
                    break;
                case 'PERSON':
                    element.registrationNumber = '';
                    break;
                default:
                    break;
            }
        }
    }
    handleChoosePlasticCardOption(element) {
        if (element) {
            switch (element.cardOption) {
                case 'PLASTIC_MULTIENERGETIC':
                    element.electromobility = true;
                    break;
                case 'PLASTIC':
                    element.electromobility = false;
                    break;
                default:
                    break;
            }
        }
    }

    render() {
        return (
            <DivContainer colClass='container-fluid auto-register'>
                <DivContainer colClass='dashboard auto-register-container'>
                    <BlockUi
                        tag='div'
                        blocking={this.state.blocking || this.state.loading}
                        loader={this.loader}
                        rendered={!this.props.embedded}
                    >
                        <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} rendered={!this.props.embedded} />
                        {/* {this.state.formChoosen === undefined ? this.renderToFormChooseButton() : null} 
                        {this.state.formChoosen === 'FIRST' ? this.renderFirstFormDetails() : this.state.formChoosen === 'SECOND' ? this.renderSecondFormDetails() : 
                        this.renderFormChoosePage() } */}

                        {this.props.formType === 'START' ? this.renderToFormChooseButton() : null}
                        {this.props.formType === 'FIRST' ? this.renderFirstFormDetails() : this.props.formType === 'SECOND' ? this.renderSecondFormDetails() :
                            this.renderFormChoosePage()}
                    </BlockUi>
                    <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} />
                </DivContainer>
            </DivContainer>
        );
    }

    renderFirstFormDetails() {
        const { t } = this.props;
        
        return (
            <React.Fragment>
                <div className='row'>

                    <div className='container-fluid'>
                        {/* { this.renderToFormChooseButton()} */}

                        <div className='auto-register' style={{ top: '0px' }}>
                            <div className='register-header'>
                                {t('autoRegistration.bankPreRegistrationFirstStepTitle')}
                            </div>
                            {this.renderFirstFormPage()}

                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }

    renderSecondFormDetails() {
        const { t } = this.props;
        return (
            <React.Fragment>
                <div className='row'>
                    <div className='container-fluid'>
                        {this.state.pageIndex !== 0 && this.state.pageIndex !== 4 ? this.renderToFormChooseButton() : null}
                        <div className='auto-register' style={{ top: '80px' }}>
                            <div className='register-header'>
                                {this.state.pageIndex !== 4 ? <div>{t('autoRegistration.moyaRegister')}</div> : null}
                                <div>{this.state.pageIndex !== 4 ? this.renderStepsNav() : null}</div>
                            </div>

                            {this.state.pageIndex === 0 ? this.renderFirstPage() : null}
                            {this.state.pageIndex === 1 ? this.renderSecondPage() : null}
                            {this.state.pageIndex === 2 ? this.renderThirdPage() : null}
                            {this.state.pageIndex === 3 ? this.renderFourthPage() : null}
                            {this.state.pageIndex === 4 ? this.renderFinalPage() : null}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

AutoRegistrationByBankContainer.defaultProps = {};

AutoRegistrationByBankContainer.propTypes = {};

export default withTranslation()(AutoRegistrationByBankContainer);
